// Copyright (c) 2017 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import actions from '../../actions-list';
import {getAuditRecords} from '../../shared/repositories';

export const readAuditRecords = auditNumber =>
    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const audit = await getAuditRecords(auditNumber);

            dispatch({
                audit,
                type: actions.UPDATE_TCSM_RECORD_AUDIT_DATA
            });

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/tcsm/record-audit/action-creators/get-audit-records.js